import axios from 'axios';
import store from '../store';
import router from '../router';
import moment from 'moment';

const baseDomain = '';
const baseAPI = `${baseDomain}/api`;

Date.prototype.toISOString = function() {
  return moment(this).format('YYYY-MM-DDTHH:mm:ss');
};

const instance = axios.create({
  baseURL: baseAPI,
});

instance.interceptors.request.use((request) => {
  if(request !== null && request.url){
    const token = store.state.token;
    const isLogin = request.url.startsWith('/auth') && request.method === 'post';

    if (token && !isLogin) {
      request.headers['Authorization'] = `Bearer ${token}`;
    } else {
      delete request.headers['Authorization'];
    }
  }

  return request;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status == 401) {
      router.push('login');
    }
    return Promise.reject(error);
  }
);

export default instance;
